import { render, staticRenderFns } from "./CompetencyCardSkeleton.vue?vue&type=template&id=031d6ef1&scoped=true"
import script from "./CompetencyCardSkeleton.vue?vue&type=script&lang=js"
export * from "./CompetencyCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CompetencyCardSkeleton.vue?vue&type=style&index=0&id=031d6ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d6ef1",
  null
  
)

export default component.exports